export default "__VITE_ASSET__vIzL5$K7__"